export enum StatusCarte {  
  valide = 1,
  complet = 2,
  perime = 3
}
